import api from "@/api.js";

export default {
  namespaced: true,
  state: {
    list: [],
    listLoading: false,
    answers: [],
    answersLoading: false
  },
  mutations: {
    setList(state, payload) {
      state.list = payload;
    },
    setListLoading(state, payload) {
      state.listLoading = payload;
    },

    setAnswers(state, payload) {
      state.answers = payload;
    },
    setAnswersLoading(state, payload) {
      state.answersLoading = payload;
    }
  },
  actions: {
    async loadAll({ commit }) {
      commit("setListLoading", true);
      let list = await api.get("sustainabilityplans/questions");
      commit("setList", list.data);
      commit("setListLoading", false);
    },
    async loadForOutcome({ commit, dispatch }, id) {
      commit("setListLoading", true);
      let list = await api.get("sustainabilityplans/questions/forOutcome", {
        params: {
          outcomes_id: id
        }
      });
      commit("setList", list.data);
      commit("setListLoading", false);
      dispatch("loadAnswersForOutcome", id);
    },

    async loadAnswersForOutcome({ commit }, id) {
      commit("setAnswersLoading", true);
      let answers = await api.get(
        "sustainabilityplans/questions/answersForOutcome",
        {
          params: {
            outcomes_id: id
          }
        }
      );
      commit("setAnswers", answers.data);
      commit("setAnswersLoading", false);
    },

    async new({ dispatch }, payload) {
      let returnData = {};
      await api
        .post("sustainabilityplans/questions", payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: err
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async save({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`sustainabilityplans/questions`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("loadAll");
      return returnData;
    },
    async select({ commit, dispatch }, payload) {
      commit("setChosenOutcome", payload);
      dispatch("questions/loadForOutcome", payload.id, { root: true });
    },
    async clearListForOutcome({ commit }, payload) {
      commit("setList", []);
    },
    async saveAllAnswers({ dispatch }, payload) {
      let returnData = {};
      await api
        .put(`sustainabilityplans/questions/saveAllAnswers`, payload)
        .then(response => {
          if (response.data.Result == "Success") {
            returnData = {
              Result: "Success",
              Response: response.data
            };
          } else {
            returnData = {
              Result: "Failed",
              Response: response.data
            };
          }
        })
        .catch(err => {
          returnData = {
            Result: "Error",
            Response: {
              Message: "There was an Error, Please try again later"
            }
          };
        });
      dispatch("outcomes/loadAllForWizard", null, { root: true });
      return returnData;
    }
  },
  getters: {
    list(state) {
      return state.list;
    },
    listLoading(state) {
      return state.listLoading;
    },
    answers(state) {
      return state.answers;
    },
    answersLoading(state) {
      return state.answersLoading;
    }
  }
};
